var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.656 4c-.289 0-.55.113-.75.313L4.313 5.905c-.399.399-.399 1.094 0 1.594l5.5 5.5-5.5 5.5c-.399.5-.399 1.195 0 1.594l1.593 1.593c.5.399 1.196.399 1.594 0l5.5-5.5 5.5 5.5c.5.399 1.195.399 1.594 0l1.593-1.593c.399-.5.399-1.196 0-1.594l-5.5-5.5 5.5-5.5c.399-.5.399-1.195 0-1.594l-1.593-1.593c-.5-.399-1.196-.399-1.594 0l-5.5 5.5-5.5-5.5C7.25 4.112 6.945 4 6.656 4z"
  })));
};

export default SvgCross;